import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './FiltersDrawer.styles';
import { BooleanCollection } from '@/components/FiltersDrawer/FiltersDrawer.types';
import { Property } from '@/api/types/categories.types';

const options = [
  { label: 'common.no_matter', value: undefined },
  { label: 'common.yes', value: true },
  { label: 'common.no', value: false },
];

type Props = {
  property: Property;
  collection: BooleanCollection;
  setCollection: React.Dispatch<React.SetStateAction<BooleanCollection>>;
};

export const BooleanOptions = ({
  property,
  collection,
  setCollection,
}: Props) => {
  const { t } = useTranslation();

  const handleChange = (value: boolean | undefined) => {
    setCollection(prev => ({ ...prev, [property.legacyResourceId]: value }));
  };

  return (
    <div data-testid={`boolean-property-${property.legacyResourceId}`}>
      <S.PropertyName $hasTopGutter>{property.name}</S.PropertyName>
      <S.OptionButtonsBox>
        {options.map(el => {
          return (
            <S.OptionButton
              key={el.label}
              $isActive={collection[property.legacyResourceId] === el.value}
              onClick={() => handleChange(el.value)}
            >
              {t(el.label)}
            </S.OptionButton>
          );
        })}
      </S.OptionButtonsBox>
    </div>
  );
};
